(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-table-of-contents"] && !Shopify.designMode) return;
  try {
    (() => {
    const placeholderText = '#Inhaltsverzeichnis#';
    const collapsedItemLimit = 10;
    const fixedHeaderSelectors = [
      '.shopify-section--announcement-bar',
      '.shopify-section--header',
      '.article__nav'
    ];

    const getTranslateY = (transformValue) => {
      const matrixMatch = transformValue.match(/^matrix\(([^)]+)\)$/);

      if (matrixMatch) {
        return Number.parseFloat(matrixMatch[1].split(',')[5]) || 0;
      }

      const matrix3dMatch = transformValue.match(/^matrix3d\(([^)]+)\)$/);

      if (matrix3dMatch) {
        return Number.parseFloat(matrix3dMatch[1].split(',')[13]) || 0;
      }

      return 0;
    };

    const getAnchorOffset = () => {
      const fixedBottom = fixedHeaderSelectors.reduce((largestBottom, selector) => {
        const element = document.querySelector(selector);

        if (!element) {
          return largestBottom;
        }

        const style = getComputedStyle(element);

        if (style.display === 'none' || (style.position !== 'fixed' && style.position !== 'sticky')) {
          return largestBottom;
        }

        const rect = element.getBoundingClientRect();
        const untranslatedBottom = rect.bottom - getTranslateY(style.transform);

        return Math.max(largestBottom, untranslatedBottom);
      }, 0);

      return Math.ceil(fixedBottom) + 16;
    };

    const navigateToHeading = (event) => {
      const anchorId = event.currentTarget.getAttribute('href').slice(1);
      const heading = document.getElementById(anchorId);

      if (!heading) {
        return;
      }

      event.preventDefault();

      const targetPosition = heading.getBoundingClientRect().top + window.scrollY - getAnchorOffset();

      window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: 'auto'
      });
      window.history.pushState(null, '', `#${anchorId}`);
    };

    const createAnchorId = (heading, index, usedIds) => {
      if (heading.id) {
        return heading.id;
      }

      const normalizedText = heading.textContent
        .trim()
        .toLocaleLowerCase('de-DE')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      const baseId = normalizedText ? `artikel-${normalizedText}` : `artikel-abschnitt-${index + 1}`;
      let uniqueId = baseId;
      let duplicateIndex = 2;

      while (usedIds.has(uniqueId)) {
        uniqueId = `${baseId}-${duplicateIndex}`;
        duplicateIndex += 1;
      }

      heading.id = uniqueId;
      usedIds.add(uniqueId);

      return uniqueId;
    };

    const configureCollapse = (tableOfContents, list) => {
      const toggle = tableOfContents.querySelector('.article-toc__toggle');
      const toggleLabel = toggle.querySelector('.article-toc__toggle-label');
      const collapsedEndItem = list.children[collapsedItemLimit - 1];
      let resizeTimeout;

      const updateHiddenItems = (isCollapsed) => {
        Array.from(list.children).forEach((item, index) => {
          const link = item.querySelector('.article-toc__link');
          const isHidden = isCollapsed && index >= collapsedItemLimit;

          if (isHidden) {
            item.setAttribute('aria-hidden', 'true');
            link.setAttribute('tabindex', '-1');
          } else {
            item.removeAttribute('aria-hidden');
            link.removeAttribute('tabindex');
          }
        });
      };

      const updateHeights = () => {
        const listStyle = getComputedStyle(list);
        const collapsedHeight =
          collapsedEndItem.offsetTop +
          collapsedEndItem.offsetHeight +
          Number.parseFloat(listStyle.paddingBottom);

        list.style.setProperty('--article-toc-collapsed-height', `${Math.ceil(collapsedHeight)}px`);
        list.style.setProperty('--article-toc-expanded-height', `${list.scrollHeight}px`);
      };

      tableOfContents.classList.add('article-toc--collapsible', 'article-toc--collapsed');
      list.id = `${tableOfContents.closest('.article__content').querySelector('.rte').id}-toc-list`;
      toggle.setAttribute('aria-controls', list.id);
      updateHiddenItems(true);

      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const willExpand = !isExpanded;

        toggle.setAttribute('aria-expanded', String(willExpand));
        toggleLabel.textContent = isExpanded ? toggle.dataset.showMore : toggle.dataset.showLess;
        tableOfContents.classList.toggle('article-toc--collapsed', isExpanded);
        tableOfContents.classList.toggle('article-toc--expanded', willExpand);
        updateHiddenItems(!willExpand);
      });

      updateHeights();

      if (document.fonts) {
        document.fonts.ready.then(updateHeights);
      }

      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(updateHeights, 100);
      });
    };

    const buildTableOfContents = (template) => {
      if (template.dataset.articleTocReady === 'true') {
        return;
      }

      const content = document.getElementById(template.dataset.contentId);

      if (!content) {
        return;
      }

      const placeholder = Array.from(content.childNodes).find(
        (node) => node.textContent.trim() === placeholderText
      );
      const headings = Array.from(content.querySelectorAll('h2')).filter(
        (heading) => heading.textContent.trim() !== ''
      );

      if (!placeholder || headings.length === 0) {
        return;
      }

      const tableOfContents = template.content.firstElementChild.cloneNode(true);
      const list = tableOfContents.querySelector('.article-toc__list');
      const itemTemplate = tableOfContents.querySelector('.article-toc__item-template');
      const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map((element) => element.id));

      headings.forEach((heading, index) => {
        const anchorId = createAnchorId(heading, index, usedIds);
        const item = itemTemplate.content.firstElementChild.cloneNode(true);
        const link = item.querySelector('.article-toc__link');

        link.href = `#${anchorId}`;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', navigateToHeading);
        list.appendChild(item);
      });

      itemTemplate.remove();
      placeholder.replaceWith(tableOfContents);

      if (headings.length > collapsedItemLimit) {
        configureCollapse(tableOfContents, list);
      }

      template.dataset.articleTocReady = 'true';
    };

    const initializeTablesOfContents = (root = document) => {
      root.querySelectorAll('template[data-article-toc-template]').forEach(buildTableOfContents);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeTablesOfContents(), { once: true });
    } else {
      initializeTablesOfContents();
    }

    document.addEventListener('shopify:section:load', (event) => initializeTablesOfContents(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
